"use client";

import * as RadixCheckbox from "@radix-ui/react-checkbox";
import { Check, Minus } from "lucide-react";
import { useId } from "react";
import type { ReactNode } from "react";

export interface CheckboxProps {
  label: ReactNode;
  checked: boolean | "indeterminate";
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
}

/** Multiple independent choices. Use Radio for mutually exclusive options. */
export function Checkbox({ label, checked, onCheckedChange, disabled, id }: CheckboxProps) {
  const autoId = useId();
  const checkboxId = id ?? autoId;
  return (
    <div className="ui-option-row">
      <RadixCheckbox.Root
        id={checkboxId}
        className="ui-checkbox-root"
        checked={checked}
        onCheckedChange={(next) => onCheckedChange(next === true)}
        disabled={disabled}
      >
        <RadixCheckbox.Indicator>
          {checked === "indeterminate" ? (
            <Minus size={13} aria-hidden="true" />
          ) : (
            <Check size={13} aria-hidden="true" />
          )}
        </RadixCheckbox.Indicator>
      </RadixCheckbox.Root>
      <label htmlFor={checkboxId}>{label}</label>
    </div>
  );
}
